export class RegisterAccountModel {
  email: string;
  password: string;
  cpf: string;
}
